import React from 'react';
import { StatusBadge, Typography, BtnIcon } from '@growthaxl/web-foundation';
import type { TimelineBlock, TimelineStep } from '../../types';

const STATUS_BADGE_VARIANT: Record<TimelineStep['status'], 'neutral' | 'info' | 'success' | 'error'> = {
  pending: 'neutral',
  running: 'info',
  completed: 'success',
  failed: 'error',
};

const STATUS_ICON: Record<TimelineStep['status'], 'check' | 'close' | 'play' | undefined> = {
  pending: undefined,
  running: 'play',
  completed: 'check',
  failed: 'close',
};

export interface TimelineBlockViewProps {
  block: TimelineBlock;
}

export function TimelineBlockView({ block }: TimelineBlockViewProps): React.ReactElement {
  return (
    <div data-testid="block-timeline" className="flex flex-col gap-1.5">
      {block.steps.map((step, i) => (
        <div key={i} className="flex items-center gap-2">
          <Typography variant="caption" color="secondary">
            <span className="inline-block w-5 text-right shrink-0">{i + 1}.</span>
          </Typography>
          <Typography variant="body2" color="primary">
            <span className="flex-1">{step.name}</span>
          </Typography>
          <StatusBadge variant={STATUS_BADGE_VARIANT[step.status] ?? 'neutral'} size="sm" styleMode="soft">
            {STATUS_ICON[step.status] && <BtnIcon name={STATUS_ICON[step.status]!} size={10} />}
            {step.status}
          </StatusBadge>
          {step.detail && (
            <Typography variant="caption" color="secondary">
              {step.detail}
            </Typography>
          )}
        </div>
      ))}
    </div>
  );
}
